
import { Component, PropSync, Vue } from 'vue-property-decorator'
import store from "@/store"

@Component({
  filters: {
  },
  components: {
  }
})
export default class DateDialog extends Vue {
  @PropSync('startedAt', { type: Number }) started!: number;
  @PropSync('dialog', { type: Boolean }) dateDialog!: boolean;
  @PropSync('ended', { type: Number || undefined }) endTime: number | undefined;

  private selectedDate: string | null = null

  private get max () {
    if (!this.endTime) return
    return (new Date(this.endTime - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
  }

  created () {
    if (!this.started) return null
    this.selectedDate = (new Date(this.started - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
  }

  private get currentLanguageCode () {
    const languageCode = this.$store.getters["global/languageCode"]
    return languageCode + '-' + languageCode
  }
}
